import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { ConfirmationOfApplication } from '@/features/ui';

import { ConditionView, StepControlPanel } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { MissingPersonExtractMergedSchema } from '../../model/types';

import { AncestralConnectionPreview, ApplicantInfoPreview } from './ApplicantInfo';
import { MissingPersonInfoPreview } from './MissingPersonInfo';

export interface DataPreviewProps {
  generatePDF: (formData: MissingPersonExtractMergedSchema) => Promise<void>;
  shouldBeAbleToUpdateProfile: boolean;
}

export const DataPreview: React.FC<StepProps<DataPreviewProps>> = ({
  next,
  prev,
  generatePDF,
  shouldBeAbleToUpdateProfile,
}) => {
  const { getValues, watch } = useFormContext<MissingPersonExtractMergedSchema>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const confirmEnteredDataCorrect = watch('confirmEnteredDataCorrect');

  const handleNextStep = (): void => {
    setIsLoading(true);

    generatePDF(getValues())
      .then(() => next())
      .catch(console.error)
      .finally(() => setIsLoading(false));
  };

  return (
    <ConditionView if={!isLoading} else={<Loader />}>
      <FormBlock title="Підтвердження даних" className="form-block__data-preview">
        <MissingPersonInfoPreview />
        <ApplicantInfoPreview />
        <AncestralConnectionPreview />
      </FormBlock>
      <ConfirmationOfApplication
        updateProfileLabelElement="Я хочу додати/оновити свій профіль згідно даних, які введені в цьому запиті"
        shouldBeAbleToUpdateProfile={shouldBeAbleToUpdateProfile}
      />
      <StepControlPanel prev={prev} next={handleNextStep} disabledNext={!confirmEnteredDataCorrect} />
    </ConditionView>
  );
};
